/**
 * Runtime Configuration Loader
 * Charge les variables d'environnement depuis config.json au runtime
 * Avec fallback intelligent basé sur la détection du domaine
 */

let runtimeConfig = null;

export const loadRuntimeConfig = async () => {
  if (runtimeConfig) return runtimeConfig;

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    runtimeConfig = await response.json();
    console.log('✅ Configuration runtime chargée depuis config.json:', runtimeConfig);
    return runtimeConfig;
  } catch (error) {
    console.warn('⚠️ config.json non disponible, détection automatique du domaine');
    
    // Détection automatique basée sur le domaine
    const hostname = window.location.hostname;
    const isTestEnv = hostname === 'test.aqiboost.com';
    const isProd = hostname === 'aqiboost.com' || hostname === 'www.aqiboost.com' || hostname === 'aqiboost.fr' || hostname === 'www.aqiboost.fr';
    
    let apiBaseUrl, socketUrl;
    
    if (isTestEnv) {
      // Environnement de test Green
      apiBaseUrl = 'https://test.aqiboost.com/api/v1';
      socketUrl = 'https://test.aqiboost.com';
      console.log('🟢 Environnement détecté: GREEN (test)');
    } else if (isProd) {
      // Environnement de production Blue
      apiBaseUrl = 'https://aqiboost.com/api/v1';
      socketUrl = 'https://aqiboost.com';
      console.log('🔵 Environnement détecté: BLUE (production)');
    } else {
      // Fallback sur les variables compilées (dev local)
      // En dev, utiliser une URL relative pour passer par le proxy setupProxy.js
      // IMPORTANT: Ignorer process.env.REACT_APP_API_BASE_URL s'il contient une URL absolue
      // et utiliser l'URL relative /api/v1 pour le proxy
      const envApiUrl = process.env.REACT_APP_API_BASE_URL;
      if (envApiUrl && envApiUrl.startsWith('http')) {
        // Si c'est une URL absolue, l'ignorer et utiliser l'URL relative
        apiBaseUrl = '/api/v1';
      } else {
        apiBaseUrl = envApiUrl || '/api/v1';
      }
      // En local: forcer le backend local pour éviter d'utiliser une URL
      // distante injectée via env (sinon les événements supervision ne
      // correspondent pas au backend local en cours de debug).
      const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
      const envSocketUrl = process.env.REACT_APP_SOCKET_URL;
      if (isLocalHost) {
        socketUrl = `${window.location.protocol}//${window.location.hostname}:8000`;
      } else {
        socketUrl = envSocketUrl || `${window.location.protocol}//${window.location.hostname}:8000`;
      }
      console.log('💻 Environnement détecté: DEVELOPMENT (local)');
      console.log('🔗 API Base URL:', apiBaseUrl);
      console.log('🔗 Socket URL:', socketUrl);
    }
    
    runtimeConfig = {
      REACT_APP_API_BASE_URL: apiBaseUrl,
      REACT_APP_SOCKET_URL: socketUrl,
      REACT_APP_TURN_URL_1: process.env.REACT_APP_TURN_URL_1 || 'turn:turn.aqiboost.com:3478',
      REACT_APP_TURN_URL_2: process.env.REACT_APP_TURN_URL_2 || 'turn:turn.aqiboost.com:3478?transport=tcp',
      REACT_APP_TURN_URL_3: process.env.REACT_APP_TURN_URL_3 || 'turns:turn.aqiboost.com:5349?transport=tcp',
      REACT_APP_TURN_USERNAME: process.env.REACT_APP_TURN_USERNAME || 'aqiboost',
      REACT_APP_TURN_CREDENTIAL: process.env.REACT_APP_TURN_CREDENTIAL || 'rSdspOfun+DIykaaOWMRP7xc5u4f1kp/5I3W+hCrDD4=',
    };
    
    console.log('✅ Configuration générée automatiquement:', runtimeConfig);
    return runtimeConfig;
  }
};

export const getRuntimeConfig = () => {
  if (!runtimeConfig) {
    throw new Error('Configuration non chargée. Appelez loadRuntimeConfig() d\'abord.');
  }
  return runtimeConfig;
};

export const getApiBaseUrl = () => getRuntimeConfig().REACT_APP_API_BASE_URL;
export const getSocketUrl = () => getRuntimeConfig().REACT_APP_SOCKET_URL;
export const getTurnConfig = () => ({
  url1: getRuntimeConfig().REACT_APP_TURN_URL_1,
  url2: getRuntimeConfig().REACT_APP_TURN_URL_2,
  url3: getRuntimeConfig().REACT_APP_TURN_URL_3,
  username: getRuntimeConfig().REACT_APP_TURN_USERNAME,
  credential: getRuntimeConfig().REACT_APP_TURN_CREDENTIAL,
});
